var _metadata, _clipPath, _clipPath2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagellanLogoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg10",
    xmlSpace: "preserve",
    width: 504.63867,
    height: 91.358673,
    viewBox: "0 0 504.63867 91.35867",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata16"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), /*#__PURE__*/React.createElement("defs", {
    id: "defs14"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 71.457,75.372 c -4.696,0 -8.504,-3.807 -8.504,-8.504 v 0 -25.511 c 0,-4.697 3.808,-8.504 8.504,-8.504 v 0 h 25.512 c 4.697,0 8.504,3.807 8.504,8.504 v 0 25.511 c 0,4.697 -3.807,8.504 -8.504,8.504 v 0 z",
    id: "path24"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(42.519684,0,0,-42.519684,62.953384,54.112503)",
    spreadMethod: "pad",
    id: "linearGradient38"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#18b3b3"
    },
    offset: 0,
    id: "stop32"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00a19a"
    },
    offset: 0.505587,
    id: "stop34"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#008c86"
    },
    offset: 1,
    id: "stop36"
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,117.269 H 377.729 V 0 H 0 Z",
    id: "path46"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,156.35867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "matrix(1.5141844,0,0,1.5141844,-93.11693,0.62412406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g22",
    clipPath: "url(#clipPath26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 71.457,75.372 c -4.696,0 -8.504,-3.807 -8.504,-8.504 v 0 -25.511 c 0,-4.697 3.808,-8.504 8.504,-8.504 v 0 h 25.512 c 4.697,0 8.504,3.807 8.504,8.504 v 0 25.511 c 0,4.697 -3.807,8.504 -8.504,8.504 v 0 z",
    style: {
      fill: "url(#linearGradient38)",
      stroke: "none"
    },
    id: "path40"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g42",
    transform: "matrix(1.5141844,0,0,1.5141844,-93.11693,0.62412406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g44",
    clipPath: "url(#clipPath48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g50",
    transform: "translate(72.3503,46.2385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.372,0.173 -0.763,0.255 -1.148,0.255 -1.024,0 -2.006,-0.581 -2.468,-1.571 -0.634,-1.362 -0.045,-2.981 1.317,-3.616 0.372,-0.173 0.763,-0.255 1.148,-0.255 1.024,0 2.005,0.582 2.467,1.572 C 1.951,-2.253 1.362,-0.635 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g54",
    transform: "translate(76.0012,64.2556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 0.371,-0.96 c 0.169,0.097 0.338,0.195 0.523,0.268 0.254,0.101 0.516,0.169 0.781,0.216 L 1.298,0.501 C 0.526,2.499 -0.9,2.918 -1.96,2.918 c -0.717,0 -1.375,-0.177 -1.962,-0.529 -1.03,-0.634 -1.574,-1.6 -1.574,-2.794 v -16.176 c 0.228,0.041 0.46,0.069 0.697,0.069 0.236,0 0.466,-0.034 0.694,-0.075 v 16.182 c 0,0.715 0.29,1.226 0.905,1.605 0.367,0.22 0.772,0.327 1.24,0.327 C -1.372,1.527 -0.529,1.368 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g58",
    transform: "translate(80.8879,60.8737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.554,1.397 -2.135,2.082 -3.532,1.528 -4.93,0.975 -5.614,-0.607 -5.06,-2.004 -4.507,-3.401 -2.925,-4.085 -1.528,-3.532 -0.131,-2.979 0.553,-1.397 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g62",
    transform: "translate(95.4821,65.5232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.715,-0.374 1.048,-0.906 1.048,-1.673 v -10.171 c 0.226,0.04 0.457,0.071 0.696,0.071 0.238,0 0.468,-0.031 0.695,-0.071 v 10.171 c 0,1.286 -0.62,2.291 -1.79,2.904 -0.525,0.278 -1.143,0.419 -1.834,0.419 -1.02,0 -2.398,-0.419 -3.17,-2.416 l -5.101,-13.217 c -0.354,-0.917 -1.169,-1.245 -1.814,-1.245 -0.644,0 -1.459,0.328 -1.813,1.245 l -1.92,4.978 c -0.208,-0.131 -0.426,-0.246 -0.659,-0.339 -0.206,-0.081 -0.418,-0.137 -0.631,-0.184 l 1.913,-4.957 c 0.5,-1.296 1.721,-2.134 3.11,-2.134 1.391,0 2.612,0.838 3.112,2.134 l 5.1,13.217 c 0.53,1.369 1.323,1.527 1.873,1.527 C -0.723,0.259 -0.325,0.172 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g66",
    transform: "translate(97.2258,52.4997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.503,0 -2.721,-1.219 -2.721,-2.721 0,-1.503 1.218,-2.722 2.721,-2.722 1.503,0 2.721,1.219 2.721,2.722 C 2.721,-1.219 1.503,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "scale(1,-1)",
    style: {
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "48.4539px",
      fontFamily: "'Gill Sans MT'",
      InkscapeFontSpecification: "GillSansMT",
      writingMode: "lr-tb",
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.51419
    },
    id: "text72",
    x: 96.823723,
    y: -79.261925
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "96.823723 139.51161 174.73276 215.43404 244.50638 273.09418 301.68198 338.84613",
    y: -79.261925,
    id: "tspan70",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontFamily: "Arial",
      InkscapeFontSpecification: "Arial",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.51419
    }
  }, "MAGELLAN")), /*#__PURE__*/React.createElement("text", {
    transform: "scale(1,-1)",
    style: {
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "16.6561px",
      fontFamily: "'Caviar Dreams'",
      InkscapeFontSpecification: "CaviarDreams-Bold",
      writingMode: "lr-tb",
      fill: "#00a19a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.51419
    },
    id: "text76",
    x: 98.773392,
    y: -52.28825
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "98.773392 113.18085 128.53772 145.23206 164.4198 180.05981 190.34489 207.21744 226.60509 236.14899 250.93121 272.11768 285.94217 303.06458 317.47208 327.75717 348.94366 365.81619",
    y: -52.28825,
    id: "tspan74",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial Bold'",
      strokeWidth: 1.51419
    }
  }, "TRACKING SOLUTIONS"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagellanLogoGreen);
export default __webpack_public_path__ + "static/media/magellan_logo_green.4e4592080807ed7c5dbc9843b627c908.svg";
export { ForwardRef as ReactComponent };